import React from "react";
import { Button } from "../ui/button";
import { IMAGES } from "../../lib/restaurantData";
import { MapPin, Clock } from "lucide-react";
import { useT } from "../../lib/i18n";

export const Hero = () => {
  const { t } = useT();
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full flex items-end overflow-hidden"
    >
      <img
        src={IMAGES.hero}
        alt="Mama Cucina e Pizza"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0E1F35]/90 via-[#0E1F35]/50 to-[#0E1F35]/35" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16 sm:pb-24 pt-32 w-full">
        <div className="max-w-3xl animate-fade-up">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#B59410]" />
            <span className="font-display text-xs sm:text-sm text-[#E8C765] tracking-[0.32em] font-semibold">
              {t("hero.eyebrow")}
            </span>
            <span className="h-px w-10 bg-[#B59410]" />
          </div>
          <img
            src="/brand/logo-mama.png"
            alt="Mama Cucina e Pizza"
            data-testid="hero-logo"
            className="h-40 sm:h-56 lg:h-72 w-auto brightness-0 invert"
          />
          <p className="mt-7 text-stone-100/95 text-base sm:text-lg max-w-xl leading-relaxed font-serif-body">
            {t("hero.tagline")}
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Button
              data-testid="hero-prenota-btn"
              onClick={() => scrollTo("#prenota")}
              className="font-display text-xs tracking-[0.22em] rounded-full bg-[#B59410] hover:bg-[#8E7308] text-white px-8 py-6 font-semibold transition-transform hover:-translate-y-1 hover:shadow-2xl"
            >
              {t("hero.bookCta")}
            </Button>
            <Button
              data-testid="hero-menu-btn"
              variant="outline"
              onClick={() => scrollTo("#menu")}
              className="font-display text-xs tracking-[0.22em] rounded-full border-white/40 bg-white/10 backdrop-blur text-white hover:bg-white hover:text-[#1E3A5D] px-8 py-6 font-semibold"
            >
              {t("hero.menuCta")}
            </Button>
          </div>

          <div className="mt-10 flex flex-wrap gap-x-8 gap-y-3 text-stone-100/80 text-sm font-serif-body">
            <span className="flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#E8C765]" />
              Via Udine 81, Lignano Sabbiadoro
            </span>
            <span className="flex items-center gap-2">
              <Clock className="w-4 h-4 text-[#E8C765]" />
              {t("hero.open")}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
